import React from 'react'
import { Container, Title, Item, Icon } from './ProductTooltip.style'

const ProductTooltip = ({ product, group }) => (
    <Container data-testid={`${group.desc}Tooltip`}>
        <Title>O que é {group.desc}?</Title>
        <Item>
            <div>
                <Icon
                    src={group.icon}
                    alt={`Icone ${product.name} ${group.desc}`}
                />
            </div>
            <p>{group.tooltipDesc}</p>
        </Item>
    </Container>
)

export default ProductTooltip
